import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'app/services/utils.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { WelcomeListResource } from 'app/models/WelcomeListResource';

@Component({
  selector: 'vbn-welcome-list',
  templateUrl: './welcome-list.component.html',
  styleUrls: ['./welcome-list.component.scss']
})
export class WelcomeListComponent implements OnInit {

  userEmail: string;
  errorMessage: any;
  welcomeList: WelcomeListResource;
  constructor(
    private service: UtilsService,
    private router: Router,
    private _notificationService: NotificationsService,
    private translate: TranslateService,
  ) { 
    this.welcomeList= new WelcomeListResource();
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getWelcomeList();
  }
  
  getWelcomeList(): void {
    this.service.get(`admin/welcome/getAll?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          this.welcomeList = response;
        },
        error => this.errorMessage = <any>error);
  }

  delete(rid) {
    this.service.get(`admin/welcome/delete?userEmail=${this.userEmail}&id=${rid}` )
      .subscribe(
        response => {
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Welcome was deleted!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })

          this.getWelcomeList();
        },
        error => this.errorMessage = <any>error);
  }

  edit(rid) {
    this.router.navigate(['/edit-welcome/' + btoa('{ "welcomeRid" : "' + rid + '"}')]);
  }

}
